import { AlertBox, AlertBoxDismissButton } from "@vp/swan";
import React, { FC, memo, useEffect, useMemo, useState } from "react";

import "../styles/Snackbar.scss";
import { Translations } from "../utils/Translation";

export type SnackbarMessageType = "error" | "warning" | "standard" | "positive" | "legal-warning";

interface SnackbarProps {
  dismissTimeout?: number;
  message: string;
  messageType: SnackbarMessageType;
  showMessage?: boolean;
  onSnackbarDismiss?: () => void;
}

const Snackbar: FC<SnackbarProps> = ({
  message,
  showMessage = false,
  messageType,
  dismissTimeout = 5000,
  onSnackbarDismiss,
}: SnackbarProps) => {
  const [dismissed, setDismissed] = useState(true);

  useMemo(() => {
    setDismissed(!showMessage);
  }, [showMessage]);

  const onRequestDismiss = () => {
    setDismissed(true);
    onSnackbarDismiss?.();
  };

  useEffect(() => {
    if (!dismissed) {
      setTimeout(() => {
        onRequestDismiss();
      }, dismissTimeout);
    }
  }, [dismissed, dismissTimeout]);

  return (
    <AlertBox
      dismissed={dismissed}
      skin={messageType}
      onRequestDismiss={onRequestDismiss}
      className="snackbar-alert"
    >
      {message}
      <AlertBoxDismissButton
        accessibleText={Translations.getInstance().getTranslation("dismissAlert")}
      />
    </AlertBox>
  );
};

export default memo(Snackbar);
